import React from "react";
import ConveyorScene from "./ConveyorScene";
import { motion } from "framer-motion";

const HeroSection = () => {
  return (
    <div className="relative w-full h-screen">
      <ConveyorScene />
      <div className="absolute inset-0 z-10 flex items-end justify-between px-24 py-10 text-white font-IBM">
        <div className="space-y-10">
          <motion.div
            initial={{ y: 90, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            className="flex flex-col space-y-4 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-500"
          >
            <p className="text-5xl font-Gilroy">Expect swift delivery.</p>
            <p className="text-lg">beyond your expectation</p>
          </motion.div>

          <motion.div
            initial={{ x: -90, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            className="flex font-medium space-x-7 text-nav text-textColor"
          >
            <p>Software Development</p>
            <div className="h-5 w-[1.5px] bg-textColor -rotate-[29.24deg]" />
            <p>Cybersecurity</p>
            <div className="h-5 w-[1.5px] bg-textColor -rotate-[29.24deg]" />
            <p>Web\App Design</p>
          </motion.div>
        </div>

        <div className="space-y-14">
          <motion.div
            initial={{ y: 90, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            className="flex items-center space-x-5"
          >
            <div className="h-14 w-[2px] bg-white " />
            <p className="w-64 font-medium leading-tight text-textColor text-nav">
              eCyberNest delivers exceptional, quality products that go beyond
              expectations.
            </p>
          </motion.div>

          <motion.div
            initial={{ x: 90, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            className="flex space-x-4 text-xs"
          >
            <div className="flex items-center p-px cursor-pointer bg-gradient-to-r from-gray-300 to-gray-600 rounded-3xl">
              <div className="text-gray-200 bg-black rounded-[calc(1.5rem-1px)] px-6 py-3">
                Contact Us
              </div>
            </div>

            <div className="flex items-center p-px cursor-pointer bg-gradient-to-r from-gray-300 to-gray-600 rounded-3xl">
              <div className="text-gray-200 bg-black rounded-[calc(1.5rem-1px)] pl-6 pr-3 py-2">
                <div className="flex items-center space-x-3">
                  <span>Get started</span>
                  <div className="flex items-center justify-center w-6 h-6 text-xs font-semibold text-black bg-white rounded-full">
                    +
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
